import { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { fetchDashboardMe, signOut, type DashboardMe } from '../lib/auth.js';

export function DashboardPage() {
  const navigate = useNavigate();
  const [me, setMe] = useState<DashboardMe | null>(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchDashboardMe()
      .then((data) => {
        if (cancelled) return;
        if (!data) {
          navigate({ to: '/login' });
          return;
        }
        setMe(data);
      })
      .catch((e: unknown) => {
        if (!cancelled) setErr(e instanceof Error ? e.message : 'Failed');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (loading) return <main className="max-w-3xl mx-auto p-12 text-brand-muted">Loading...</main>;

  if (err) {
    return (
      <main className="max-w-3xl mx-auto p-12">
        <p className="text-red-700">{err}</p>
      </main>
    );
  }

  if (!me) return null;

  return (
    <main className="max-w-3xl mx-auto px-6 py-12">
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-semibold text-brand-primary">
            Welcome, {me.user.email}
          </h1>
          <p className="text-brand-muted mt-1">
            {me.merchant.legalName} · role: {me.user.role}
          </p>
        </div>
        <button
          onClick={async () => {
            await signOut();
            navigate({ to: '/login' });
          }}
          className="text-sm text-brand-primary underline"
        >
          Sign out
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-md p-6">
        <p className="text-sm text-brand-muted">
          Merchant status:{' '}
          <span className="font-medium text-brand-body">{me.merchant.status}</span>
        </p>
        <p className="text-sm text-brand-muted mt-1">
          Full dashboard ships in M5 (transactions list, settlement view, support, etc.).
        </p>
      </div>
    </main>
  );
}
